import React from 'react';
import { injectIntl } from 'react-intl';
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
  Label,
} from 'recharts';
import { isNumber as _isNumber, get as _get } from 'lodash';

import { parseQs } from 'helpers/http';

class VklBarChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initialData: props.data,
      data: props.data,
    };
  }

  handleBarClick = event => {
    const { timespan } = event;

    if (!this.isSingleYearView()) {
      if (this.props.onYearSelect) {
        this.props.onYearSelect(timespan);
      }
    } else if (this.props.onMonthSelect) {
      this.props.onMonthSelect(timespan);
    }
  };

  isSingleYearView = () => {
    const query = parseQs(this.props.location.search);

    return !!query.year && query.year.length === 1;
  };

  getBar = (name, dataKey, color) => {};

  render() {
    const { intl } = this.props;
    const messages = intl.messages;

    const hasPreviousYear = _isNumber(_get(this.state, 'data[0].count_businesses_previous'));

    return (
      <div>
        <ResponsiveContainer height={450} width="100%">
          <ComposedChart data={this.state.data} margin={{ top: 20, right: 0, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="timespan" />
            <YAxis>
              <Label value={messages.count} position="insideLeft" angle={-90} textAnchor="middle" />
            </YAxis>
            <YAxis
              yAxisId="right"
              type="number"
              unit="%"
              orientation="right"
              stroke="#e57373"
              dataMin="0"
              dataMax="100"
            >
              <Label value={messages.sad.conversion_rate} position="insideRight" angle={90} textAnchor="middle" />
            </YAxis>
            <Tooltip />
            <Legend />
            <Bar name={messages.sad.offers} dataKey="count_businesses" fill="#1E88E5" onClick={this.handleBarClick}>
              {!hasPreviousYear && (
                <LabelList dataKey="count_businesses" position="center" stroke="#212121" strokeWidth="0.8" />
              )}
            </Bar>
            {hasPreviousYear && (
              <Bar
                name={messages.sad.offers + ' (' + messages.previous_year + ')'}
                dataKey="count_businesses_previous"
                fill="#90CAF9"
                onClick={this.handleBarClick}
              />
            )}
            <Bar name={messages.sad.orders} dataKey="count_orders" fill="#43A047" onClick={this.handleBarClick}>
              {!hasPreviousYear && (
                <LabelList dataKey="count_orders" position="center" stroke="#212121" strokeWidth="0.8" />
              )}
            </Bar>
            {hasPreviousYear && (
              <Bar
                name={messages.sad.orders + ' (' + messages.previous_year + ')'}
                dataKey="count_orders_previous"
                fill="#A5D6A7"
                onClick={this.handleBarClick}
              />
            )}
            <Line
              name={messages.sad.conversion_rate}
              type="monotone"
              yAxisId="right"
              dataKey="conversion_rate"
              stroke="#e53935"
              strokeWidth="3"
            >
              {!hasPreviousYear && (
                <LabelList dataKey="conversion_rate" position="top" stroke="#e57373" strokeWidth="0.8" offset={7} />
              )}
            </Line>
            {hasPreviousYear && (
              <Line
                name={messages.sad.conversion_rate + ' (' + messages.previous_year + ')'}
                type="monotone"
                yAxisId="right"
                dataKey="conversion_rate_previous"
                stroke="#ef9a9a"
                strokeWidth="3"
              />
            )}
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

export default injectIntl(VklBarChart);
